import { cilMenu, cilPencil, cilX, cilPlus } from '@coreui/icons';
export const icons = Object.assign({
  cilMenu,
  cilPencil,
  cilX,
  cilPlus,
});
